import { useCookie } from 'nuxt/app'
import { resolveCookieDomain } from '@/utils/cookieDomain'

export const useCrossDomainCookie = () => {
  const getHostname = () => {
    if (process.server) {
      // 服务端：从请求头获取
      const req = useRequestEvent()?.node?.req;
      return req?.headers.host || '';
    } else {
      // 客户端：从 window.location 获取
      return window.location.hostname;
    }
  };
  // 获取一级域名
  function getBaseDomain() {
    const hostname = getHostname();
    return resolveCookieDomain(hostname)
  };

  function getCookieOptions(options: any = {}) {
    const domain = getBaseDomain()
    return {
      maxAge: 365 * 24 * 60 * 60 - 60,
      sameSite: true,
      path: '/',
      ...options,
      ...(domain ? { domain: `.${domain}` } : {}),
    }
  }

  // 创建跨域共享的 cookie
  const createCrossDomainCookie = async (name: string, value?: any, options: any = {}) => {
    const baseDomain = getBaseDomain()
    let isDevelopment = process.env.NODE_ENV === 'development'
    const newOptions = getCookieOptions(options)

    // 本地/IP 环境无法设置 Domain Cookie；同时保留既有非 token 本地域 Cookie。
    if (!baseDomain || isDevelopment || name != 'pdf_token') {
      let localCookie = useCookie(name, {
        maxAge: 365 * 24 * 60 * 60 - 60,
        sameSite: true,
        path: '/',
        ...options,
      })
      localCookie.value = value
    }
    let crossDomainCookie = useCookie(`domian_${name}`, newOptions)
    crossDomainCookie.value = value
    return crossDomainCookie
  }

  // 获取跨域 cookie
  const getCrossDomainCookie = (name: string) => {
    return useCookie(`domian_${name}`, getCookieOptions())
  }

  // 设置跨域 cookie
  const setCrossDomainCookie = async (name: string, value: any, options: any = {}) => {
    return createCrossDomainCookie(name, value, options)
  }

  // 删除跨域 cookie
  const removeCrossDomainCookie = (name: string) => {
    const cookie = getCrossDomainCookie(name)
    cookie.value = null
    // 设置过期时间为过去的时间
    cookie.value = undefined
  }

  // 检查 cookie 是否存在
  const hasCrossDomainCookie = (name: string) => {
    const cookie = getCrossDomainCookie(name)
    return !!cookie.value
  }

  return {
    createCrossDomainCookie,
    getCrossDomainCookie,
    setCrossDomainCookie,
    removeCrossDomainCookie,
    hasCrossDomainCookie
  }
}
